import { useSearchParams } from 'react-router-dom';
import { CampanhaParameters } from '../infra/routes/campanhaRoutes';
import { _UserData } from 'base/src/infra/storage/localStorage';

/**
 * Resolve o campanhaId da URL (query param) ou dos claims do access_token (localStorage).
 * Retorna null se não encontrado em nenhuma das fontes.
 */
export function useCampanhaId(): string | null {
	const [searchParams] = useSearchParams();

	const fromUrl = searchParams.get(CampanhaParameters.campanhaId);
	if (fromUrl) return fromUrl;

	const fromClaims = _UserData.GetOtherData<string>('CampanhaID');
	if (fromClaims && fromClaims !== 'undefined') return fromClaims;

	return null;
}
